import { render, staticRenderFns } from "./TeamStats.vue?vue&type=template&id=9daf308c&"
import script from "./TeamStats.vue?vue&type=script&lang=js&"
export * from "./TeamStats.vue?vue&type=script&lang=js&"
import style0 from "./TeamStats.vue?vue&type=style&index=0&id=9daf308c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports